import React from 'react';
import LoanCalculator from './components/LoanCalculator';
import './App.css';

const App = (props) => {
  // Create appConfig from props or use defaults
  const appConfig = {
    productApiUrl: props.apiUrl,
    productId: props.offerId,
    applyUrl: props.applyUrl,
    loanAmountLabel: props.loanAmountLabel,
    monthlyLabel: props.monthlyLabel || "Monthly Installment",
    durationLabel: props.durationLabel || "Duration",
    infoLinkLabel: props.infoLinkLabel || "View SECCI Document",
    submitLabel: props.submitLabel || "Apply Now",
    footerText: props.footerText,
    loginLabel: props.loginLabel,
    monthsLabel: props.monthsLabel,
    apiErrorMessage: props.apiErrorMessage,
    warningTitle: props.warningTitle,
    warningContent: props.warningContent,
    numDecimalMonthly: props.numDecimalMonthly
  };

  return (
    <div className="App">
      <LoanCalculator appConfig={appConfig} />
    </div>
  );
};

export default App;
